import { FormikProps } from 'formik'
import { FC } from 'react'
import { CloningFormFields, CloningTypes } from '../../types'
import { CloningTypeRadio } from './CloningTypeRadio'

interface Props {
  formik: FormikProps<CloningFormFields>
  setCurrentCloningType: (value: CloningTypes) => void
}

export const RadioButtons: FC<Props> = ({ formik, setCurrentCloningType }) => {
  return <CloningTypeRadio formik={formik} setCurrentCloningType={setCurrentCloningType} />
}
